import { Component, DoCheck, IterableChanges, IterableDiffer, IterableDiffers, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import * as countdown from 'countdown';
import firebase from 'firebase/app';
import { Tutor } from '../core/clases/tutor.model';
import { FirebaseAuthComponent } from '../shared/firebase-auth/firebase-auth.component';
import { BillableConceptsService } from '../shared/services/billable_concepts/billable-concepts.service';
import { SendEmailService } from '../shared/services/email/send-email.service';
import { InscripcionService } from '../shared/services/inscripcion/inscripcion.service';
import { PagoService } from '../shared/services/pago/pago.service';
import { RedsysService } from '../shared/services/redsys/redsys.service';
import { SeriesService } from '../shared/services/series/series.service';
import { TutorService } from '../shared/services/tutor/tutor.service';

@Component({
  selector: 'app-resultok',
  templateUrl: './resultok.component.html',
  styleUrls: ['./resultok.component.scss']
})
export class ResultokComponent implements OnInit, DoCheck {

  // secret=  'bjFpfWkzoi4bm97VbHA/Ge1M+iUZQ8o5' // real
  secret = 'sq7HjrUOBfKmC576ILgskD5srU870gJ7' // prueba
  tutor = new Tutor();
  tutorAux: any;
  alumnos: Array<any> = [];
  conceptosCostos: Array<any> = [];
  numeroRecibo: number = 0;
  valorTotalDescuentos: number = 0;
  valorTotal: number = 0;
  valorTotalAPagar: number = 0;
  totalAlumnos = 0;
  resultRedsys: any;
  centro = '';
  mostrarMensajeConfirmacion = false;
  private _diff: IterableDiffer<any>;
  powerOffIcon = faPowerOff;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    private tutorService: TutorService,
    private pagoService: PagoService,
    private inscripcionService: InscripcionService,
    private seriesService: SeriesService,
    private redsysService: RedsysService,
    private _iterableDiffers: IterableDiffers,
    private billableConceptsService: BillableConceptsService,
    private emailService: SendEmailService,
    public firebaseAuth: FirebaseAuthComponent,
  ) { }

  ngDoCheck() {
    const changes: IterableChanges<number> = this._diff.diff(this.alumnos)
    if (changes) {
      if (this.totalAlumnos > 0 && this.alumnos.length === this.totalAlumnos) {
        let noVariosAlumnos = true;
        this.alumnos.forEach(alumno => {
          if (noVariosAlumnos) {
            this.obtenerConceptosCostosAlumno(alumno);
            if (alumno.idDescuentoFecha == null || alumno.idDescuentoFecha == '') {
              this.establecerConceptosAlumno(alumno, 'RTT9zmOGPS2eoDc63SAN');
            }
            noVariosAlumnos = false;
          } else {
            this.obtenerConceptosCostosAlumno(alumno);
            if (alumno.idDescuentoFecha == null || alumno.idDescuentoFecha == '') {
              this.establecerConceptosAlumno(alumno, 'RTT9zmOGPS2eoDc63SAN');
            }
            this.establecerConceptosAlumno(alumno, 'YG4oyAmRgYn11jm4y4GZ');
          }
        });
        this.actualizarEstadoAlumnosYRecibo();
      }
    }
  }


  ngOnInit(): void {
    this._diff = this._iterableDiffers.find(this.alumnos).create();
    let id = this.route.snapshot.params['idTutor'];
    if (id) {
      const urlTree = this.router.parseUrl(this.router.url);
      const jsonRespuestaRedsys = {
        Ds_SignatureVersion: urlTree.queryParams['Ds_SignatureVersion'],
        Ds_MerchantParameters: urlTree.queryParams['Ds_MerchantParameters'],
        Ds_Signature: urlTree.queryParams['Ds_Signature'],
        secret: this.secret
      }
      this.redsysService.decodeRedsysResponse(jsonRespuestaRedsys).then(result => {
        if (result && (result.Ds_AuthorisationCode || result.DS_AUTHORISATIONCODE) &&
          (result.Ds_Response === '0000' || result.DS_RESPONSE === '0000')) {
          this.resultRedsys = result;
          this.billableConceptsService.getBillableConceptsCollection().subscribe(res => {
            this.conceptosCostos = res;
            this.obtenerTutor(id);
          });
        } else {
          this.router.navigate([`pago/${id}`]);
        }
      })
    }
  }

  async obtenerTutor(id): Promise<void> {
    await this.tutorService.getUser(id).subscribe(res => {
      this.tutorAux = res;
      this.tutor.id = this.tutorAux.id;
      if (this.tutorAux != null) {
        this.tutorAux.paymentMethod = 'AsVzKZ33P2kzDTqQYsrM';
        this.tutor.paymentMethod = 'AsVzKZ33P2kzDTqQYsrM';
        this.totalAlumnos = this.tutorAux.alumns.length;
        this.establecerDatosAlumnos(this.tutorAux.alumns);
        this.inicializarContador(this.tutorAux);
      }
    });
    console.log(this.alumnos);
  }

  inicializarContador(tutor): void {
    tutor.timeId = countdown(tutor.courseSelectedTime, (ts) => {
      tutor.time = ts;
    });
  }

  establecerDatosAlumnos(alumnosTutor): void {
    if (alumnosTutor != null) {
      alumnosTutor.forEach(async element => {
        await this.tutorService.getUser(element.id).subscribe(res => {
          this.agregarAlumno(res);
        });
      });
    }
    console.log(this.alumnos);
  }

  agregarAlumno(alumno): void {
    let banderaInsertar = true;
    this.alumnos.forEach(element => {
      if (element.id == alumno.id) {
        banderaInsertar = false;
      }
    });
    if (banderaInsertar) {
      if (alumno.status != 'test' && alumno.status != 'matriculado' && alumno.status != 'espera' && alumno.status != 'ninguno') {
        this.alumnos.push(alumno);
        this.obtenerConceptosCostosAlumno(alumno);
      }
    }
  }

  obtenerConceptosCostosAlumno(alumno): void {
    alumno.valorTotal = 0;
    alumno.totalDescuentos = 0;
    alumno.idBillableConcepts = [];
    alumno.billable = [];
    alumno.idDescuentoFecha = null;
    this.asignarDescuentoPorFecha(alumno);
    alumno.billableConceptsStudent.filter(bill => {
      const billSpli = bill.idCourse.split('/');
      if (alumno.idLastCourse === billSpli[1]) {
        return bill;
      }
    }).orElse([{ billableConcepts: [] }])[0]
      .billableConcepts.forEach(concepto => {
        this.establecerConceptosAlumno(alumno, concepto.id);
      });
    /*alumno.billableConceptsStudent[0].billableConcepts.forEach(concepto => {
      this.establecerConceptosAlumno(alumno, concepto.id);
    });*/
    if (alumno.idDescuentoFecha != null && alumno.idDescuentoFecha != '') {
      this.establecerConceptosAlumno(alumno, alumno.idDescuentoFecha);
    }
  }

  establecerConceptosAlumno(alumno, idConcepto): void {
    this.conceptosCostos.forEach(element => {
      if (element.id == idConcepto) {
        alumno.billable.push({
          amount: element.amount,
          billableConcepts: 'billable_concepts/' + element.id,
          billableConceptsDescription: element.concept,
          discount: 0,
          iva: element.iva,
          netPayment: element.total
        });
        alumno.idBillableConcepts.push(firebase.firestore().doc(`/billable_concepts/${element.id}`));
        this.calcularTotalesConceptos(alumno, element);
      }
    })
  }

  calcularTotalesConceptos(alumno, concepto): void {
    let cantidad: number;
    cantidad = Number(concepto.total);
    if (cantidad < 0) {
      this.valorTotalDescuentos = this.valorTotalDescuentos + cantidad;
      alumno.totalDescuentos = alumno.totalDescuentos + cantidad;
    } else {
      this.valorTotal = this.valorTotal + cantidad;
      alumno.valorTotal = alumno.valorTotal + cantidad;
    }
    alumno.valorTotalAPagar = alumno.totalDescuentos + alumno.valorTotal;
    this.valorTotalAPagar = this.valorTotalDescuentos + this.valorTotal;
  }

  private establecerNumeroRecibo(alumno: any, numeroRecibo): void {
    if (numeroRecibo < 100) {
      alumno.numeroRecibo = '00' + numeroRecibo;
    } else {
      if (numeroRecibo < 1000) {
        alumno.numeroRecibo = '0' + numeroRecibo;
      }
      else {
        alumno.numeroRecibo = numeroRecibo;
      }
    }
  }

  async actualizarEstadoAlumnosYRecibo(): Promise<void> {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.alumnos.length; i++) {
      await this.obtenerSerieYActualizar(this.alumnos[i]);
    }
  }

  async obtenerSerieYActualizar(alumno): Promise<void> {
    // tslint:disable-next-line: deprecation
    let serieAux;
    await this.seriesService.getSerie(alumno.idLastSerie).then(async serie => {
      serieAux = serie.data();
    });
    let numeroRecibo = 0;
    const accounting = alumno.billableConceptsStudent.filter(bill => {
      const billSpli = bill.idCourse.split('/');
      if (alumno.idLastCourse === billSpli[1]) {
        return bill;
      }
    }).orElse([{ accounting: '' }])[0].accounting;

    if (accounting == 'recibo') {
      numeroRecibo = serieAux?.counter + 1;
      alumno.nameSerie = serieAux?.name;
      await this.actualizarSerieCounter(alumno.idLastSerie, numeroRecibo);
    } else {
      numeroRecibo = serieAux?.counterFactura + 1;
      await this.actualizarSerieCounterFactura(alumno.idLastSerie, numeroRecibo);
      alumno.nameSerie = serieAux?.name;
    }
    this.establecerNumeroRecibo(alumno, numeroRecibo);
    await this.accionesPagar(alumno);
  }

  private async accionesPagar(alumno: any): Promise<void> {
    try {
      const authorisationCode = this.resultRedsys.Ds_AuthorisationCode || this.resultRedsys.DS_AUTHORISATIONCODE;
      await this.pagoService.insertarRecibo(alumno, this.tutor, 'pagado', authorisationCode).then(async () => {
      }).catch(
        (error) => {
          console.log('fallo la generación del recibo ' + error);
          throw error;
        }
      );
      await this.tutorService.updateUserStatusFinishInscription(alumno, 'matriculado').then(async () => {
        alumno.lastStatusCourses.courseStatus = 'matriculado';
        alumno.lastStatusCourses.statusStudentCourse = 'matriculado';
        alumno.status = 'matriculado';
        await this.tutorService.setLastStatusCourse(alumno).then(async () => {
        }).catch((error) => {
          console.log('error al cambiar el statusCourse a matriculado ' + error);
          throw error;
        });
      }).catch((error) => {
        console.log('error al cambiar el estado a matriculado ' + error);
        throw error;
      });
      await this.inscripcionService.actualizarEstadoInscripcion(alumno.inscripcionId, 'matriculado').then(async () => {
      }).catch((error) => {
        console.log('error al cambiar el estado a matriculado ' + error);
        throw error;
      });
      await alumno.courses.filter(cour => cour.id === alumno.idLastCourse)
        .orElse([{
          get: () => {
            return { then: () => { } };
          }
        }])[0].get().then(async course => {
          const courseData = course.data();
          const centro = await courseData.center.get();
          const centroData = centro.data();
          const municipio = await centroData.town.get();
          const municipioData = municipio.data();
          // if (this.alumnos[this.alumnos.length] == alumno) {
          //   this.cargando = false;
          // }
          // console.log('los datos son ', courseData, ' ', centroData, ' ', municipioData);
          this.enviarEmail('Confirmación de matrícula',
            this.emailMatricula(alumno?.fullname, courseData, centroData, municipioData),
            this.tutorAux.email);
        });
    } catch (error) {
      console.log(error);
    }
    this.mostrarMensajeConfirmacion = true;

  }

  async actualizarSerieCounter(idSerie, numeroRecibo): Promise<void> {
    // tslint:disable-next-line: deprecation
    await this.seriesService.updateCounter(idSerie, numeroRecibo).then(serie => {
    }).catch(
      (error) => {
        console.log('fallo actualizacion de la serie' + error);
      }
    );
  }

  async actualizarSerieCounterFactura(idSerie, numeroRecibo): Promise<void> {
    // tslint:disable-next-line: deprecation
    await this.seriesService.updateCounterFactura(idSerie, numeroRecibo).then(serie => {
    }).catch(
      (error) => {
        console.log('fallo actualizacion de la serie' + error);
      }
    );
  }

  asignarDescuentoPorFecha(alumno): void {

    let idDescuento: string;
    try {
      const endDateLastCourse = this.segundosToDateUTC(alumno.endDateLastCourse.seconds);
      const primerDia = new Date();
      let ultimoDia = new Date(primerDia.getFullYear(), primerDia.getMonth() + 1, 0);
      const diaSemana = this.obtenerNumeroDia(alumno.dayLastCourse);
      const hora = alumno.starTimeLastCourse.hour;
      const distance = diaSemana - primerDia.getDay();
      if (distance >= 0) {
        primerDia.setDate(primerDia.getDate() + distance);
      } else {
        primerDia.setDate(primerDia.getDate() + distance + 7);
      }
      primerDia.setHours(hora);
      primerDia.setMinutes(0);
      if ((endDateLastCourse.getFullYear() == primerDia.getFullYear())
        && (endDateLastCourse.getMonth() == primerDia.getMonth())) {
        ultimoDia = endDateLastCourse;
      }
      ultimoDia.setHours(23);
      ultimoDia.setMinutes(59);
      if (primerDia < ultimoDia) {
        primerDia.setDate(primerDia.getDate() + 7);
        if (primerDia < ultimoDia) {
          primerDia.setDate(primerDia.getDate() + 7);
          if (primerDia < ultimoDia) {
            primerDia.setDate(primerDia.getDate() + 7);
            if (primerDia < ultimoDia) {
            } else {
              idDescuento = 'AN9nXvyp6oDb4rSDikPM';
            }
          } else {
            idDescuento = 'qnxWGjE89SWBTfN8quoh';
          }
        } else {
          idDescuento = 'zJkJVTzf711n3HIlvRPa';
        }
      }
    } catch (e) {
      console.log(e);
    }
    alumno.idDescuentoFecha = idDescuento;
  }

  segundosToDateUTC(secs): Date {
    const t = new Date(Date.UTC(1970, 0, 1));
    t.setUTCSeconds(secs);
    return t;
  }

  obtenerNumeroDia(dia: string): number {
    let numeroDia: number;
    switch (dia) {
      case 'Lunes':
        numeroDia = 1;
        break;
      case 'Martes':
        numeroDia = 2;
        break;
      case 'Miercoles':
        numeroDia = 3;
        break;
      case 'Jueves':
        numeroDia = 4;
        break;
      case 'Viernes':
        numeroDia = 5;
        break;
      case 'Sabado':
        numeroDia = 6;
        break;
      case 'Domingo':
        numeroDia = 0;
        break;
      default:
        numeroDia = 1;
        break;
    }
    return numeroDia;

  }

  enviarEmail(subjectToSend: string, messageToSend: string, emailToSend: string): Promise<any> {
    return this.emailService.sendEmail(subjectToSend, messageToSend, emailToSend)
      .then((responseSus) => {
        // console.log('el resultado de la function es ', responseSus);
        if (responseSus) {
          if (responseSus.error) {
          }
        }
        return responseSus;
      }).catch(error => {
      });
  }

  emailMatricula(nombreAlumno: string, course: any, centro: any, municipio: any): string {
    const messageEmail = `<div style ="text-align: justify;">
    Hola ${this.tutorAux.fullname}<br/>

    la matrícula de ${nombreAlumno} ha sido completada correctamente.<br/><br/>

    Centro: ${centro.description} - ${municipio.municipality}<br/><br/>

    Curso: ${course.description}<br/><br/>

    Día: ${course.weekDays[0]}<br/><br/>

    Hora: ${course.startTime.hour}:${course.startTime.minute}-${course.endTime.hour}:${course.endTime.minute}<br/><br/>

    Gracias por tu matrícula.<br/>

    <img class="product-image" style="max-width: 100%;"
    src="https://firebasestorage.googleapis.com/v0/b/playbotscms.appspot.com/o/logo_playbots.png?alt=media&token=2ddbe96b-349c-4819-8b2e-18256f0ef7ff" />
    <br/><br/>

    Avda. de las Civilizaciones 15, local 9<br/>
    41927 Mairena del Aljarafe, Sevilla<br/>
    Tlf.: 854993164 - info@playbots.es<br/><br/>

    Este correo electrónico y, en su caso, cualquier fichero anexo, contiene información confidencial <br/>
    exclusivamente dirigida a su(s) destinatario(s). Toda copia o divulgación deberá ser autorizada por <br/>
    Playbots Education S.L. <br/><br/>

    This e-mail and any attachments are confidential and exclusively directed to its address(es). Any<br/>
    copy or distribution will have to be authorized by Playbots Education S.L.<br/><br/>

    En virtud de la ley 34/2002 LSSI-CE, este mensaje y sus archivos adjuntos pueden contener<br/>
    información confidencial, por lo que se informa de que su uso no autorizado está prohibido por la<br/>
    ley, además se encuentran protegidos por la Constitución Española, que garantiza la<br/>
    confidencialidad, protección y secreto de las comunicaciones. Si ha recibido este mensaje por<br/>
    equivocación, por favor notifíquelo inmediatamente a través de esta misma vía y borre el mensaje<br/>
    original junto con sus ficheros adjuntos sin leerlo o grabarlo total o parcialmente. Los datos<br/>
    personales que consten en esta comunicación son responsabilidad de Playbots Education S.L.<br/>
    con la finalidad de gestionar la relación con nuestros clientes y contactos en relación al ejercicio<br/>
    de nuestra actividad, todo ello bajo la legitimación otorgada por consentimiento expreso del propio<br/>
    interesado, y/o en base a la ejecución de un contrato de servicios. No se cederán datos a terceros<br/>
    salvo obligaciones legales. En cuanto a sus derechos podrá acceder, rectificar y suprimir los datos,<br/>
    limitarlos o incluso oponerse a su tratamiento, entre otros derechos, contactando con nosotros por<br/>
    email o por correo postal dirigido a Avda. de las Civilizaciones 15, local 9 - 41927 Mairena del<br/>
    Aljarafe, Sevilla.<br/><br/>

    </div>`;

    return messageEmail;
  }

  logout(): void {
    this.firebaseAuth.eliminarInscripcionesAlumnos(this.alumnos);
    this.firebaseAuth.logout();
    localStorage.removeItem('idTutor');
  }
}
